export default __webpack_public_path__ + "static/media/up.009714e2.svg";